import {throttle} from './utils';

const labHeader = (() => {
  const announcementBar = document.querySelector('#announcement-bar');
  const headerEl = document.querySelector('#header');
  // Hide header on scroll
  let prevScrollPos = 0;

  function toggleAnnouncementBar(currScrollPos) {
    if (!window.showAnnouncementScrollUp) {
      if (currScrollPos > headerEl.offsetHeight / 2) {
        announcementBar.style.transform = 'translateY(-100%)';
        announcementBar.style.maxHeight = '0';
        announcementBar.style.overflow = 'hidden';
      } else if (currScrollPos === 0) {
        announcementBar.style.transform = 'translateY(0)';
        announcementBar.style.maxHeight = '50px';
        announcementBar.style.overflow = 'auto';
      }
    }
  }
  const toggleHeader = throttle(() => {
    const currentScrollPos = window.pageYOffset;

    if (
      !document.body.classList.contains('modal-open') &&
      prevScrollPos < currentScrollPos &&
      currentScrollPos > headerEl.offsetHeight / 2
    ) {
      document.documentElement.style.setProperty('--header-transform', 'translateY(-100%)');
    } else {
      toggleAnnouncementBar(currentScrollPos);
      document.documentElement.style.setProperty('--header-transform', 'translateY(0)');
    }
    prevScrollPos = currentScrollPos;
  }, 100);

  window.addEventListener('scroll', toggleHeader);

  // Set wrapper height to push content below header - on resize
  const resizeObserver = new ResizeObserver(
    throttle(() => {
      document.documentElement.style.setProperty('--header-height', `${headerEl.offsetHeight}px`);
    }, 500)
  );

  // older browser support
  const toggleResize = throttle(() => {
    document.documentElement.style.setProperty('--header-height', `${headerEl.offsetHeight}px`);
  }, 500);

  if (window.ResizeObserver) {
    toggleResize();
    resizeObserver.observe(headerEl);
  } else {
    toggleResize();
    window.addEventListener('resize', toggleResize);
  }
})();

export default labHeader;
